import { FC, useContext } from "react";

import { AuthContext } from "src/context/authContext";
import { FooterLogo, ProductBasedLogo } from "../../assets";
import { useLocation } from "react-router-dom";

const FooterText: FC = (): JSX.Element | null => {
    const { isUserAuthorized } = useContext(AuthContext);
    const location = useLocation();

    return location.pathname !== "/enrollment" ? (
        <div className={`${!isUserAuthorized ? "pb-3 pb-xl-5" : "mb-4"}`}>
            <div className="row justify-content-start align-items-center pt-3 footer-trademark gap-3 gap-md-0">
                <div className="col min-col">
                    <img
                        height={80}
                        src={isUserAuthorized ? ProductBasedLogo : FooterLogo}
                        alt="alternate logo"
                    />
                </div>

                <div className="col">
                    <p className="mb-0">
                        QUTENZA® is a registered trademark of Averitas Pharma, Inc.
                    </p>
                    <p className="mb-0">©2025 Averitas Pharma, Inc. All rights reserved.</p>
                    <p className="mb-0">QZA-09-22-0022 v6.0 May 2024</p>
                </div>

                {isUserAuthorized && (
                    <div className="col text-end">
                        <img height={80} src={FooterLogo} alt="alternate logo" />
                    </div>
                )}
            </div>
        </div>
    ) : null;
};

export default FooterText;